module.exports = __webpack_public_path__ + "img/BGyellow2.76fe4178.png";